import Image from "next/image";
import { memo } from "react";

import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import { blurDataURL } from "@config/config";
import { useStore } from "@hooks/useZustandProvider";
import Container from "@ui-kit/Container/Container";
import Slider from "@ui-kit/Slider/Slider";
import SliderControls from "@ui-kit/Slider/SliderControls";
import SliderSlides from "@ui-kit/Slider/SliderSlides";

import { typeSlider } from "./datas";
import s from "./GaleryV7Block.module.scss";

const GaleryV7Block = ({ settings, data, updateField }) => {
  const { cms } = useStore();
  const { isEditMode } = cms.uiOptions;
  const { title, collections } = data;
  const { sliderV7 } = collections;
  const { items } = sliderV7;
  const { blockType } = settings.common;

  const filteredItems = items.filter((item) => {
    return typeof item.isShow === "boolean" ? item.isShow : true;
  });

  return !!filteredItems.length || isEditMode ? (
    <Container className={s.galeryV7}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <Slider
            collectionType={typeSlider}
            // autoScroll
            startPadding
            className={s.slider}
            slidesCount={filteredItems.length}
            render={(sliderProps) => {
              return (
                <>
                  <SliderSlides
                    {...sliderProps}
                    className={s.slides}
                    wrapClassName={s.wrapSlides}
                  >
                    {filteredItems.map((slide = {}, key) => (
                      <div key={key} className={s.slide}>
                        <Image
                          fill
                          style={{
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                          src={slide.image}
                          alt={slide.alt}
                          quality={100}
                          blurDataURL={blurDataURL}
                        />
                      </div>
                    ))}
                  </SliderSlides>
                  <SliderControls className={s.controls} {...sliderProps} />
                </>
              );
            }}
          />
        </section>
      </Container>
    </Container>
  ) : null;
};

export default memo(GaleryV7Block);
